import axios from '../api/index.js';

//上传图片
export let postUploadPhoto = (params) => {
    let data = new FormData();
    data.append('file', params);
    return axios.post(`/manager/common/upload`, data);
};

// 获取地域信息
export let getQueryChina = (data) => {
    return axios.get(`/client/common/areaList/${data}`)
}

//上传证件照
export let postUploadUserPhoto = (params) => {
    let data = new FormData();
    data.append('file', params);
    return axios.post(`/manager/common/upload/photo`, data);
};



// WEBPACK FOOTER //
// ./src/api/common.js